<!-- Page Wrapper -->
<div id="main">
  <!-- Sidebar -->
  <div class="nav-wrapper d-flex flex-column flex-shrink-0">
    <app-menu></app-menu>
  </div>

  <div id="content-wrapper">
    @if (loading()) {
    <div class="loading-overlaying" [class.loading-overlaying--fullscreen]="isFullscreenRoute">
      <mat-progress-spinner [mode]="'indeterminate'"></mat-progress-spinner>
    </div>
    }
    <!-- Begin Page Content -->
    <div id="page-content" #scrollableContent (scroll)="applyBlurryEffect()" class="container-fluid">
      <router-outlet></router-outlet>
      <div [ngClass]="{ visible: isBottomBlurryEffectVisible }" class="blurry-on-bottom"></div>
      <app-custom-notification-toast></app-custom-notification-toast>
    </div>
  </div>
  <!-- End Page Content -->
</div>
<!-- End of Page Wrapper -->

@if(isAuthenticated){
<app-confirm-dialog></app-confirm-dialog>
<app-orders-dialogs-host></app-orders-dialogs-host>
@if(isStagingEnvironment) {
<app-zendesk></app-zendesk>
} }

<ng-template #idleMessage>
  <div class="idle-message">
    <mat-icon class="me-3">report_problem</mat-icon>
    Session inactive, déconnexion prévue dans {{ idlecountdown }}
  </div>
</ng-template>
